<template>
<div>
    <div class="sub-container">
    <div class="contact-header">
        <el-button class="btn-add-contact" type="primary" icon="el-icon-plus" @click="contactDialogVisible = true">新建患者</el-button>
        <!-- <el-button class="btn-add-contact" icon="el-icon-delete" @click="mutiDelete">批量删除</el-button> -->
        <el-input class="input-circle" v-model="searchText" placeholder="姓名或出生日期"></el-input>
        <el-button class="input-search" round type="primary" @click="search">搜 索</el-button>
    </div>
    <div class="divider"></div>
    <el-table :data="currentContactArray" style="width: 1110px" :border="tableBorder" v-show="currentContactArray.length > 0">
        <el-table-column
            prop="name"
            align='left'
            label="姓名"
            width="70">
        </el-table-column>
        <el-table-column
            prop="sexText"
            label="性别"
            align='left'
            width="60">
        </el-table-column>
        <el-table-column
            prop="birthday"
            label="公历生日"
            align='left'
            width="120">
        </el-table-column>
        <el-table-column
            prop="lunarBirthday"
            label="农历生日"
            align='left'
            width="170">
        </el-table-column>
        <el-table-column
            prop="phoneNo"
            label="电话号码"
            align='left'
            width="130">
        </el-table-column>
        <el-table-column
            prop="liveArea"
            label="常住地址"
            align='left'
            width="210">
        </el-table-column>
        <el-table-column
            prop="birthArea"
            label="出生地址"
            align='left'
            width="210">
        </el-table-column>
        <el-table-column
            fixed="right"
            label=""
            align='center'
            width="140">
            <template slot-scope="scope">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    <el-button
                    type="text"
                    size="medium">
                    操作
                    </el-button>
                    <i class="el-icon-arrow-down el-icon--right" style="color: royalblue;"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native.prevent="startPrescription(scope.$index)"><el-button
                      type="text"
                      size="medium">
                      去开方
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native.prevent="drugRecord(scope.$index)">
                      <el-button
                        type="text"
                        size="medium">
                        就诊记录
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native.prevent="editRow(scope.$index)">
                      <el-button
                        type="text"
                        size="medium">
                        编辑
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native.prevent="deleteRow(scope.$index)">
                      <el-button
                        type="text"
                        size="medium">
                        删除
                      </el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
            </template>
        </el-table-column>
    </el-table>
    <el-pagination
        v-if="totalPage > 10"
        class="pagination"
        background
        layout="prev, pager, next"
        :current-page="currentPageNo"
        @current-change="pageChange"
        :total="totalPage">
    </el-pagination>
    <div class="empty-container" v-if="currentContactArray.length == 0">
        <span>{{emptyText}}</span>
    </div>
</div>
<el-dialog
    title="编辑患者信息"
    :visible.sync="contactDialogVisible"
    width="800px"
    center
    custom-class="contact-dialog"
    destroy-on-close
    :close-on-click-modal="dialogClose">
        <div class="dialog-wrapper">
            <el-form :model="currentEditContact" label-width="100px" label-position="left" class="dialog-form">
                <el-form-item label="*姓名" style="width: 100%;">
                    <el-input v-model="currentEditContact.name" autocomplete="off" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="*性别">
                    <el-radio-group v-model="currentEditContact.sex">
                        <el-radio-button class="radio-button-one" label="1" size="medium">男</el-radio-button>
                    </el-radio-group>
                    <el-radio-group v-model="currentEditContact.sex">
                        <el-radio-button label="0" size="medium">女</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="currentEditContact.phoneNo" autocomplete="off" placeholder="请输入手机号码"></el-input>
                </el-form-item>
                <el-form-item label="*出生日期">
                    <!-- <el-date-picker
                        class="dialog-picker"
                        v-model="currentEditContact.birthday"
                        default-value="2000-01-01"
                        placeholder="请选择出生日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        @change="birthDateChange"
                        type="date" :editable="editable" prefix-icon="clear"> -->
                    <!-- </el-date-picker> -->

                    <el-input v-model="currentEditContact.displayBirth" autocomplete="off" placeholder="请选择出生日期" @focus="showBirthdayDialog"></el-input>
                    <!-- <el-checkbox style="margin-left: 20px; font-size: 32px;padding-bottom: 10px;" v-model="checkedNongLi">显示农历</el-checkbox> -->
                </el-form-item>
                <span style="color: #dd3131;font-size: 16px;margin-left: 100px;">在本系统其他页面，只展示阳历（公历）生日。</span>
                <el-form-item label="*常住地址">
                    <el-cascader
                    class="address-picker1"
                    :filterable="true"
                    popper-class="address-cascader"
                    size="medium"
                    placeholder="选择或根据省市区搜索常住地址"
                    v-model="currentEditContact.liveArea"
                    :options="areaOptions"></el-cascader>
                </el-form-item>
                <el-form-item label="*出生地址">
                    <el-cascader
                    class="address-picker2"
                    :filterable="true"
                    size="medium"
                    placeholder="选择或根据省市区搜索出生地址"
                    v-model="currentEditContact.birthArea"
                    :options="areaOptions"></el-cascader>
                    <el-button v-show="copyVisible" style="margin-left: 20px;" type="success" plain @click="copyAddress" size="small" round>和常住地一致</el-button>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button class="btn-dialog-cancel" @click="contactDialogVisible = false">取 消</el-button>
                <el-button class="btn-dialog-confirm" :loading="confirmLoading" type="primary" @click="addContactConfirm">确 认</el-button>
            </span>
            <span style="width: 100%;padding-left: 100px;margin-top: 30px;font-size: 18px;color: #666;">温馨提示：<br />
                        1、加*为必填项。<br />
                        2、请务必核实阳历、阴历生日。<br />
                        3、请确认各项信息准确。<br />
                        4、在本系统中其他页面，只展示阳历（公历）生日，请您注意。</span>
        </div>
        </el-dialog>

        <el-dialog
          title="选择出生日期"
          :close-on-press-escape="false"
          :visible.sync="birthdayDialogShow"
          width="800px"
          center>
          <div class="dialog-wrapper">
            <el-radio-group v-model="currentDateType">
              <el-radio-button label="0">阳历(公历)</el-radio-button>
              <el-radio-button label="1">阴历(农历)</el-radio-button>
            </el-radio-group>
            <span style="font-size: 20px;margin-top: 20px;">{{currentDateType == 0?'阳历(公历)':'阴历(农历)'}}</span>
            <div style="width: 100%;display: flex;flex-direction: row;align-items: center;justify-content: center;margin-top: 30px;">
              <el-select style="width: 100px;" v-model="currentYear" placeholder="年份" @visible-change="handleYearVisibleChange" ref="selectYearRef">
                <el-option
                  v-for="item in years"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
              <span style="margin-left: 10px;margin-right: 40px;font-size: 18px;">年</span>
              <el-select style="width: 100px;" v-model="currentMonth" placeholder="月份" @visible-change="handleMonthVisibleChange" ref="selectMonthRef">
                  <el-option
                    v-for="item in months"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
                <span style="margin-left: 10px;margin-right: 40px;font-size: 18px;">月</span>
                <el-select style="width: 100px;" v-model="currentDay" placeholder="日期" @visible-change="handleDayVisibleChange" ref="selectDayRef">
                    <el-option
                      v-for="item in days"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                  <span style="margin-left: 10px;margin-right: 40px;font-size: 18px;" v-show="currentDateType == '0'">日</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="btn-dialog-cancel" @click="birthdayDialogShow = false">取 消</el-button>
                <el-button class="btn-dialog-confirm" type="primary" @click="setBirthdayData">确 定</el-button>
            </span>
          </div>

        </el-dialog>
</div>

</template>

<script>
import store from '../../store'
import date from '../../js/date'
import calendar from 'js-calendar-converter'
export default {
    data () {
        return {
            years:[],
            months:[],
            days:[],
            currentYear:'',
            currentMonth:"",
            currentDay:"",
            contactArray:[],
            tableBorder:false,
            searchText:'',
            currentDateType:"0",
            currentContactArray:[],
            currentPageNo: 1,
            pageSize:8,
            totalPage: 1,
            searchCurrentPageNo:1,
            searchTotalPage:1,
            searchContactArray:[],
            maxDate: new Date(),
            emptyText:'您还没有患者',
            dialogClose:false,
            contactDialogVisible:false,
            currentEditContact:{
                sex:'1',
                birthday:"",
                birthArea:[],
                liveArea:[]
            },
            copyVisible:false,
            editable:false,
            checkedNongLi:false,
            confirmLoading:false,
            showCalendar:false,
            birthdayDialogShow:false,
            props: {
                value:'label'
            }
        }
    },
    computed: {
        areaOptions() {
            var area = this.$store.state.areaInfo;
            if(!area || !Array.isArray(area.province_list)) return [];
            
            var provinces = [];
             var citiesMap = {}; 
             var countiesMap = {}; 
             
             // 1. Prepare Counties
             if(area.county_list){
                 area.county_list.forEach(county => {
                     var cCode = county.parentAreaCode;
                     if(!countiesMap[cCode]) countiesMap[cCode] = [];
                     countiesMap[cCode].push({
                         value: county.areaCode,
                         label: county.name
                     });
                 });
             }
             
             // 2. Prepare Cities
             if(area.city_list){
                 area.city_list.forEach(city => {
                     var pCode = city.parentAreaCode;
                     if(!citiesMap[pCode]) citiesMap[pCode] = [];
                     
                     var cityNode = {
                         value: city.areaCode,
                         label: city.name
                     };
                     if(countiesMap[city.areaCode] && countiesMap[city.areaCode].length > 0) {
                         cityNode.children = countiesMap[city.areaCode];
                     }
                     citiesMap[pCode].push(cityNode);
                 });
             }
             
             // 3. Prepare Provinces
             if(area.province_list){
                 area.province_list.forEach(province => {
                     var pCode = province.areaCode;
                     var provinceNode = {
                         value: pCode,
                         label: province.name
                     };
                     if(citiesMap[pCode] && citiesMap[pCode].length > 0) {
                         provinceNode.children = citiesMap[pCode];
                     }
                     provinces.push(provinceNode);
                 });
             }
            console.log(provinces)
            return provinces;
        }
    },
    mounted(){
      this.area = this.$store.state.areaInfo
      console.log(this.area)
      this.getContactList()
    },
    methods:{
        getContactList(){
            this.wjtHttp.post(this,'/api/patient/v1/list',{name:this.searchText,pageNum:this.currentPageNo,pageSize:this.pageSize},false,(res)=>{
                var data = res.data
                if(data.code == 200){
                    var contactList = data.rows
                    this.totalPage = Math.ceil(data.total / 8) * 10
                    if(!this.utils.isEmptyStr(contactList)){
                        for(var i=0;i<contactList.length;i++){
                            contactList[i].sexText = contactList[i].sex == "1"?"男":"女"
                            if(!contactList[i].lunarBirthday){
                              var birthdayArray = contactList[i].birthday.split('-')
                              var lunarDate = calendar.solar2lunar(birthdayArray[0],birthdayArray[1],birthdayArray[2])
                              contactList[i].lunarBirthday = lunarDate.lYear+'年'+lunarDate.IMonthCn+lunarDate.IDayCn
                            }
                        }
                    }
                    this.currentContactArray = contactList
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'患者查询异常，请联系管理员',
                        type:'error'
                    })
                }
            },(err)=>{
                console.log(err)
            })
        },
        birthAddressChange(){
          this.copyVisible = true

        },
        copyAddress(){
          var birthAddress = document.getElementsByClassName('address-picker2')
          this.currentEditContact.birthArea = this.currentEditContact.liveArea
          birthAddress[0].firstChild.children[0].value = this.currentEditContact.liveArea
          // birthAddress[0].firstChild.children[0].value = this.currentEditContact.birthArea.join(' / ')
        },
        search(){
          this.currentPageNo = 1
          this.getContactList()
        },
        startPrescription(index){
          sessionStorage.setItem('contactList',JSON.stringify(this.currentContactArray[index]))
          this.$router.push({
            path:'/addPrescriptionContact',
            query:{
              mode:1
            }
          })
        },
        drugRecord(index){
          var contact = this.currentContactArray[index]
          sessionStorage.setItem('contactInfo',JSON.stringify(contact))
          this.$router.push({
            path:'/medicalRecords'
          })
        },
        editRow(index){
            this.currentEditContact = JSON.parse(JSON.stringify(this.currentContactArray[index]))
            var birthdayArray
            if(this.currentEditContact.birthday.indexOf('-')>=0){
              birthdayArray = this.currentEditContact.birthday.split('-')
            }else{
              let parts = this.currentEditContact.birthday.split(/\D+/);
              birthdayArray = parts.map(part => {
                if (part.length < 2) {
                  return '0' + part;
                }
                return part;
              }).map(Number);
            }
            var lunarObj = calendar.solar2lunar(birthdayArray[0],birthdayArray[1],birthdayArray[2])
            this.currentEditContact.displayBirth = '公历'+birthdayArray[0]+'年'+birthdayArray[1]+'月'+birthdayArray[2]+'日'+' 农历'+lunarObj.lYear+'年'+lunarObj.IMonthCn+lunarObj.IDayCn
            this.contactDialogVisible = true
            setTimeout(() => {
                var liveAddress = document.getElementsByClassName('address-picker1')
                var birthAddress = document.getElementsByClassName('address-picker2')
                liveAddress[0].firstChild.children[0].value = this.currentEditContact.liveArea
                birthAddress[0].firstChild.children[0].value = this.currentEditContact.birthArea
            }, 100);
        },
        deleteRow(index){
          this.$confirm('确定删除该患者信息吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              var contact = this.currentContactArray[index]
              this.wjtHttp.delete(this,'/api/patient/v1/'+ contact.patientId,{},false,(res)=>{
                  var data = res.data
                  if(data.code == 200){
                      this.$message({
                          message:'患者已删除',
                          type:'success'
                      })
                      this.currentEditContact = {sex:'1'}
                      this.getContactList()
                  }else{
                      this.$message({
                          message:(data.msg&&data.msg.length > 0)?data.msg:'删除失败，请联系管理员',
                          type:'error'
                      })
                  }
              },(err)=>{
                  console.log(err)
              })
          }).catch(() => {

          });
        },
        handleYearVisibleChange(visible) {
          if (visible) {
            this.$nextTick(() => {
              const selectedIndex = this.years.findIndex(
                (option) => option == this.currentYear
              );
              if (selectedIndex >= 0) {
                const selectDropdown = this.$refs.selectYearRef.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
                const dropdownList = selectDropdown.querySelectorAll('li');
                dropdownList.forEach((item)=>{
                  item.classList.remove("selected");
                })
                dropdownList[selectedIndex].classList.add("selected")
                console.log(dropdownList)
                if (selectDropdown) {
                  var scrollTop = 0
                  if(selectedIndex > 6){
                    scrollTop = 34*(selectedIndex-6)
                  }
                  selectDropdown.scrollTop = scrollTop
                }
              }
            });
          }
        },
        handleMonthVisibleChange(visible) {
          if (visible) {
            this.$nextTick(() => {
              const selectedIndex = this.months.findIndex(
                (option) => option == this.currentMonth
              );
              if (selectedIndex >= 0) {
                const selectDropdown = this.$refs.selectMonthRef.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
                const dropdownList = selectDropdown.querySelectorAll('li');
                dropdownList.forEach((item)=>{
                  item.classList.remove("selected");
                })
                dropdownList[selectedIndex].classList.add("selected")
                if (selectDropdown) {
                  var scrollTop = 0
                  if(selectedIndex > 6){
                    scrollTop = 34*(selectedIndex-6)
                  }
                  selectDropdown.scrollTop = scrollTop
                }
              }
            });
          }
        },
        handleDayVisibleChange(visible) {
          if (visible) {
            this.$nextTick(() => {
              const selectedIndex = this.days.findIndex(
                (option) => option == this.currentDay
              );
              if (selectedIndex >= 0) {
                const selectDropdown = this.$refs.selectDayRef.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
                const dropdownList = selectDropdown.querySelectorAll('li');
                dropdownList.forEach((item)=>{
                  item.classList.remove("selected");
                })
                dropdownList[selectedIndex].classList.add("selected")
                if (selectDropdown) {
                  var scrollTop = 0
                  if(selectedIndex > 6){
                    scrollTop = 34*(selectedIndex-6)
                  }
                  selectDropdown.scrollTop = scrollTop
                }
              }
            });
          }
        },
        showBirthdayDialog(){
          var birthdayArray = []
          if(this.currentEditContact.birthday){
            birthdayArray = this.currentEditContact.birthday.split('-')
          }else{
            birthdayArray = ['2000','06','15']
          }
          this.years = date.years()
          this.months = date.glMonths()
          this.days = date.glDays(birthdayArray[0],birthdayArray[1])
          this.currentYear = birthdayArray[0]
          this.currentMonth = birthdayArray[1]
          this.currentDay = birthdayArray[2]
          this.birthdayDialogShow = true
        },
        pageChange(pageNo){
            this.currentPageNo = pageNo
            this.getContactList()
        },
        birthDateChange(val){
          var flag = this.utils.afterDateFromCurrent(val)
          if(flag){
            this.$message({
              message:'出生日期必须小于当前日期',
              type:'warning'
            })
          }
        },
        setBirthdayData(){
          if(!this.currentYear){
            this.$message("请选择出生年份")
            return
          }
          if(!this.currentMonth){
            this.$message("请选择出生月份")
            return
          }
          if(!this.currentDay){
            this.$message("请选择出生日期")
            return
          }
          //公历
          if(this.currentDateType == '0'){
            var monthStr = this.currentMonth.length == 1?('0'+this.currentMonth):this.currentMonth
            var dayStr = this.currentDay.length == 1?('0'+this.currentDay):this.currentDay
            var solarDate = this.currentYear+'年'+monthStr+'月'+dayStr+'日'
            var birthday = this.currentYear+'-'+monthStr+'-'+dayStr
            var lunarDateObj = calendar.solar2lunar(this.currentYear,this.currentMonth,this.currentDay)
            console.log(lunarDateObj)
            var flag = this.utils.afterDateFromCurrent(birthday)
            if(flag){
              this.$message({
                message:'出生日期必须小于当前日期',
                type:'warning'
              })
              return
            }
            this.currentEditContact.displayBirth = '公历'+solarDate+'  农历'+lunarDateObj.lYear+'年'+lunarDateObj.IMonthCn+lunarDateObj.IDayCn
            this.currentEditContact.birthday = birthday
            this.currentEditContact.lunarBirthday = lunarDateObj.lYear+'年'+lunarDateObj.IMonthCn+lunarDateObj.IDayCn
          }else{
            var lunarDate = this.currentYear+'年'+this.currentMonth+'月'+this.currentDay
            var monthNum = date.convertLunarMonthToNumeric(this.currentMonth)
            var dayNum = date.convertLunarDayToNumeric(this.currentDay)
            var solarDateObj = calendar.lunar2solar(this.currentYear,parseInt(monthNum),dayNum,this.currentMonth.indexOf('闰')>=0)
            console.log(solarDateObj)
            var monthStr = (solarDateObj.cMonth < 10?('0'+solarDateObj.cMonth):solarDateObj.cMonth)
            var dayStr = solarDateObj.cDay < 10?('0'+solarDateObj.cDay):solarDateObj.cDay
            var solarDate = solarDateObj.cYear+'年'+monthStr+'月'+dayStr+'日'
            var birthday = solarDateObj.cYear+'-'+monthStr+'-'+dayStr
            var flag = this.utils.afterDateFromCurrent(birthday)
            if(flag){
              this.$message({
                message:'出生日期必须小于当前日期',
                type:'warning'
              })
              return
            }
            this.currentEditContact.displayBirth = '公历'+solarDate+'  农历'+lunarDate
            this.currentEditContact.birthday = birthday
            this.currentEditContact.lunarBirthday = lunarDate
          }
          this.birthdayDialogShow = false
          this.currentDateType = '0'
        },
        getName(list, code){
            if(!list || !Array.isArray(list)) return '';
            let item = list.find(x => x.areaCode == code);
            return item ? item.name : '';
        },
        addContactConfirm(){
            if(!this.currentEditContact.name || this.currentEditContact.name.length == 0){
                this.$message({
                    message:'请输入姓名',
                    type:'warning'
                })
                return
            }
            if(!this.currentEditContact.birthday || this.currentEditContact.birthday.length == 0){
                this.$message({
                    message:'请选择出生日期',
                    type:'warning'
                })
                return
            }
            if(!this.currentEditContact.liveArea || this.currentEditContact.liveArea.length == 0){
                this.$message({
                    message:'请选择常住地址',
                    type:'warning'
                })
                return
            }
            if(!this.currentEditContact.birthArea || this.currentEditContact.birthArea.length == 0){
                this.$message({
                    message:'请选择出生地址',
                    type:'warning'
                })
                return
            }
            console.log(this.currentEditContact)
            var currentEditContact = JSON.parse(JSON.stringify(this.currentEditContact))
            var liveArea = currentEditContact.liveArea
            var birthArea = currentEditContact.birthArea
            if(Array.isArray(currentEditContact.liveArea)){
              currentEditContact.liveArea = liveArea.map((key, index) => {
                if(index == 0){
                  return this.getName(this.area.province_list, key)
                }else if(index == 1){
                  return this.getName(this.area.city_list, key)
                }else{
                  return this.getName(this.area.county_list, key)
                }
              }).join('');
            }
            if(Array.isArray(currentEditContact.birthArea)){
              currentEditContact.birthArea = birthArea.map((key, index) => {
                if(index == 0){
                  return this.getName(this.area.province_list, key)
                }else if(index == 1){
                  return this.getName(this.area.city_list, key)
                }else{
                  return this.getName(this.area.county_list, key)
                }
              }).join('');
            }
            this.confirmLoading = true
            this.wjtHttp.post(this,'/api/patient/v1',currentEditContact,true,(res)=>{
                this.confirmLoading = false
                this.contactDialogVisible = false
                var data = res.data
                if(data.code == 200){
                    this.getContactList()
                    this.currentEditContact = {sex:'1'}
                    this.$message({
                        message:'操作成功',
                        type:'success'
                    })
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'编辑失败，请联系管理员',
                        type:'error'
                    })
                }
            },(err)=>{
                console.log(err)
                this.confirmLoading = false
            })
        },
    },
    watch:{
        searchText:function(val){
            if(this.utils.isEmptyStr(val)){
              this.currentPageNo = 1
              this.getContactList()
            }
        },
        contactDialogVisible:function(val){
            if(!val){
                this.currentEditContact = {sex:1}
                this.copyVisible = false
            }
        },
        birthdayDialogShow:function(val){
          if(!val){
            this.years = []
            this.months = []
            this.days = []
            this.currentYear = ''
            this.currentMonth = ''
            this.currentDay = ''
            this.currentDateType = '0'
          }
        },
        currentDateType:function(val){
          this.isDateTypeChanged = true
          if(this.birthdayDialogShow){
            if(val == '0'){ //农历切到公历
              var monthNumeric = date.convertLunarMonthToNumeric(this.currentMonth)
              var dayNumeric = date.convertLunarDayToNumeric(this.currentDay)
              console.log(monthNumeric)
              console.log(this.currentMonth)
              //农历转公历日期
              var solarDate = calendar.lunar2solar(this.currentYear,parseInt(monthNumeric),dayNumeric,this.currentMonth.indexOf('闰')>=0)
              console.log(solarDate)
              this.currentYear = solarDate.cYear
              this.currentMonth = (solarDate.cMonth < 10?('0'+solarDate.cMonth):solarDate.cMonth)
              this.currentDay = (solarDate.cDay < 10?('0'+solarDate.cDay):solarDate.cDay)
              this.months = date.glMonths()
              this.days = date.glDays(solarDate.cYear,solarDate.cMonth)
            }else{ //公历切到农历
              var lunarDate = calendar.solar2lunar(this.currentYear,this.currentMonth,this.currentDay)
              console.log(lunarDate)
              this.currentYear = lunarDate.lYear
              this.currentMonth = lunarDate.IMonthCn.replace('月','')
              this.currentDay = lunarDate.IDayCn
              this.months = date.nlMonths(lunarDate.lYear)
              this.days = date.nlDays(lunarDate.lYear,lunarDate.lMonth,lunarDate.isLeap)
            }
          }
        },
        currentYear:function(val){
          if(val && !this.isDateTypeChanged){
            if(this.currentDateType == '0'){
              if(this.currentMonth){
                this.days = date.glDays(val,this.currentMonth)
              }else{
                this.days = []
              }
              if(this.currentDay && this.currentDay>this.days[this.days.length-1]){
                this.currentDay = ""
              }
            }else{
              this.months = date.nlMonths(val)
              if(this.currentMonth && this.months.some(item => item == this.currentMonth) == false){
                this.currentMonth = ""
                this.currentDay = ''
              }
              if(this.currentMonth){
                this.days = date.nlDays(val,date.convertLunarMonthToNumeric(this.currentMonth),this.currentMonth.indexOf('闰'))
                if(this.currentDay && this.days.some(item => item == this.currentDay) == false){
                  this.currentDay = ""
                }
              }else{
                this.days = []
              }
            }
          }
        },
        currentMonth:function(val){
          if(val && !this.isDateTypeChanged){
            if(this.currentDateType == '0'){
              this.days = date.glDays(this.currentYear,val)
              if(this.currentDay && this.currentDay>this.days[this.days.length-1]){
                this.currentDay = ""
              }
            }else{
              this.days = date.nlDays(this.currentYear,date.convertLunarMonthToNumeric(val),val.indexOf('闰')>=0)
              if(this.currentDay && this.days.some(item => item == this.currentDay) == false){
                this.currentDay = ""
              }
            }
          }else{
            this.isDateTypeChanged = false
          }
        },
        'currentEditContact.liveArea': {
              handler(newValue, oldValue) {
                if(newValue && newValue.length>0){
                  this.copyVisible = true
                }
              },
              // 设置深度监听
              deep: true
            }
    }
}
</script>

<style scoped>
.sub-container{
    width: 1160px;
    height: 790px;
    margin: auto auto;
}
.el-form-item {
    margin-top: 22px !important;
    margin-bottom: 0px !important;
}
.btn-add-contact{
    font-size: 16px;
}
.custom-date-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.lunar {
  font-size: 30px;
  color: grey;
}
.contact-header{
    text-align: left;
    padding: 8px 0;
    background: #F9F9F9;
    width: 1120px;
}
.divider{
    width: 1080px;
    background: #EEEEEE;
    height: 1px;
}
.pagination{
    margin-top: 20px;
}
.input-circle{
    width: 300px;
    height: 32px;
    position: relative;
    left: 520px;
    bottom: 2px;
}
.input-search{
  height: 45px;
  width: 100px;
  position: relative;
  left: 540px;
  bottom: 2px;
}

.input-circle >>> input{
    border-radius: 30px;
    padding-left: 20px;
    padding-right: 20px;
}
.empty-container{
    width: 100%;
    height: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.empty-container>span{
    font-size: 20px;
    color: #AEAEAE;
}
.contact-dialog{
    border-radius: 10px;
}
.radio-button-one{
    margin-right: 50px;
}
.dialog-picker{
    width: 450px;
}
.address-picker1{
     width: 550px;
}
.address-picker2{
     width: 100%;
}
.dialog-form{
    width: 550px;
}
.dialog-wrapper{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.btn-dialog-cancel{
    margin-right: 50px;
    width: 150px;
    border-radius: 30px;
    margin-top: 30px;
}
.btn-dialog-confirm{
    margin-left: 50px;
    width: 150px;
    border-radius: 30px;
    margin-top: 30px;
}
.el-table__body{
  width: 1160px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/account/Contact.vue